import { QueryManagementFormat } from "@common/components/query-management";
import { SkipLogicCondition } from "@common/components/skip-logic/skip-logic.types";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { HttpSuccessDto } from "@common/dto/http";
import { clientTransformed } from "@common/utils/rest";

const URL_PREFIX = "api/formats";

const getUrl = (path: string) => {
  return `${URL_PREFIX}/${path}`;
};

export const searchQueryFormats = (params: {
  searchKeyword?: string;
}): Promise<Array<QueryManagementFormat>> => {
  return clientTransformed({
    path: getUrl("invites/query/search"),
    method: "GET",
    params: {
      query: params.searchKeyword,
    },
  }).then((response: HttpSuccessDto<Array<QueryManagementFormat>>) => {
    return response.entity;
  });
};

export const getQueryFormats = (params: {
  folder?: FolderPrimaryListDto;
}): Promise<Array<QueryManagementFormat>> => {
  const { folder } = params;

  return clientTransformed({
    path: getUrl("invites"),
    method: "GET",
    params: {
      folderId: folder?.id,
    },
  }).then((response: HttpSuccessDto<Array<QueryManagementFormat>>) => {
    return response.entity;
  });
};

export const deleteQueryFormat = (params: {
  formatId: string | number;
  context: number;
}): Promise<void> => {
  return clientTransformed({
    path: `api/spreadSheets/formats?reportNumber=${params.formatId}&context=${params.context}`,
    method: "POST",
  }).then((response: HttpSuccessDto<void>) => {
    return response.entity;
  });
};

export type QueryManagementQueryFormatGetDto = QueryManagementFormat & {
  clauses: Array<SkipLogicCondition>;
};

export const getQueryFormat = async (formatId: number | string): Promise<QueryManagementQueryFormatGetDto> => {
  return clientTransformed({
    path: getUrl(`invites/${formatId}`),
    method: "GET",
  }).then(
    (response: HttpSuccessDto<Array<QueryManagementQueryFormatGetDto>>) => {
      return response.entity;
    }
  );
};

export const saveQueryFormats = (params: {
  format: Partial<QueryManagementFormat>;
  queries: Array<SkipLogicCondition>;
}): Promise<void> => {
  const { id, name, description, folderId } = params.format;

  return clientTransformed({
    path: getUrl("invites"),
    method: "POST",
    entity: {
      id,
      name,
      description,
      folderId,
      clauses: params.queries.map(({ id, ...item }) => item),
    },
  }).then((response: HttpSuccessDto<void>) => {
    return response.entity;
  });
};
